module.exports = __webpack_public_path__ + "img/maoer.6ed547dd.gif";